/**
 * The presets the UTM builder offers.
 *
 * Suggestions, not a closed set. Every field that uses these is a text input
 * with a datalist behind it, so anything can be typed — a channel this list
 * has never heard of must not be unreachable just because marketing invented
 * it last week. The presets exist so that the common ones are spelled the same
 * way every time, which is the whole reason source and medium analytics add up.
 */

/** Where the click came from. */
export const SOURCES = [
  'whatsapp', 'email', 'sms', 'facebook', 'instagram', 'google', 'google_ads',
  'linkedin', 'youtube', 'qr_code', 'website', 'telegram', 'other'
];

/** How it was paid for or carried. */
export const MEDIUMS = [
  'marketing', 'organic', 'paid', 'social', 'email', 'sms', 'referral',
  'advertisement', 'campaign'
];

/** The five a campaign moves through. */
export const CAMPAIGN_STATUS = ['Draft', 'Active', 'Paused', 'Completed', 'Archived'];

/** A link is only ever one of three. Only Active redirects. */
export const LINK_STATUS = ['Active', 'Paused', 'Archived'];

/** Pill tone per status, matching the tones the rest of the workspace uses. */
export const STATUS_TONE = {
  Active: 'p-green',
  Draft: 'p-grey',
  Paused: 'p-amber',
  Completed: 'p-blue',
  Archived: 'p-grey'
};

/** The icon that goes with a source, where one of ours fits it. */
export const SOURCE_ICON = {
  whatsapp: 'chat',
  email: 'mail',
  sms: 'sms',
  facebook: 'mega',
  instagram: 'mega',
  linkedin: 'users',
  youtube: 'mega',
  google: 'search',
  google_ads: 'target',
  qr_code: 'grid',
  website: 'building',
  telegram: 'send'
};

export default { SOURCES, MEDIUMS, CAMPAIGN_STATUS, LINK_STATUS, STATUS_TONE, SOURCE_ICON };
